/* Картичарница: бутони и страница за снимки от гостите. Без галерия. */
(() => {
  'use strict';

  const cfg = window.POKANI || {};
  const endpoint =
    String(cfg.url || '').replace(/\/+$/, '') + '/functions/v1/pokani-photo-guest';

  const params = new URLSearchParams(location.search);
  const pathSlug = location.pathname.match(/^\/a\/p\/([a-z0-9-]+)/);
  const slug = params.get('s') || (pathSlug && pathSlug[1]) || '';

  if (slug.length > 200 || !/^[a-z0-9]+(-[a-z0-9]+)*$/.test(slug)) return;

  const MAX_BYTES = 20971520;
  const MAX_FILES = 100;
  const LIMIT_CODES = [
    'VISITOR_LIMIT',
    'INVITATION_RATE_LIMIT',
    'INVITATION_DAILY_LIMIT',
    'GLOBAL_DAILY_LIMIT'
  ];

  const invitation = document.getElementById('invitation');
  const uploadPage = document.getElementById('photoUpload');
  const visitKey = 'pokani-photo-visit-' + slug;
  const returnKey = 'pokani-photo-return-' + slug;
  const cacheKey = 'pokani-photo-available-' + slug;

  function uploadUrl() {
    const url = new URL('/pages/pokana', location.origin);
    url.searchParams.set('view', 'pokani-snimki');
    url.searchParams.set('s', slug);
    if(window.POKANI_LANG?.guest==='en'||new URLSearchParams(location.search).get('lang')==='en')url.searchParams.set('lang','en');
    return url.href;
  }

  async function checkAvailable(useCache) {
    if (useCache) {
      try {
        const cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
        if (cached && Date.now() - cached.t < 300000) return cached.v === true;
      } catch (e) {}
    }

    const response = await fetch(endpoint, {
      method: 'POST',
      credentials: 'omit',
      cache: 'no-store',
      redirect: 'error',
      signal: AbortSignal.timeout(15000),
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'check', slug })
    });

    let data = null;
    try {
      data = await response.json();
    } catch (e) {}

    const available =
      response.ok && !!data && data.ok === true && data.available === true;

    try {
      sessionStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), v: available }));
    } catch (e) {}

    return available;
  }

  /* ---------- Бутони в самата покана ---------- */

  if (invitation) {
    let returning = false;
    let available = false;

    try {
      const timestamp = Number(sessionStorage.getItem(returnKey));
      sessionStorage.removeItem(returnKey);
      returning = timestamp > 0 && Date.now() - timestamp < 1800000;
    } catch (e) {}

    const skipEnvelope = () => {
      if (!returning) return;
      document.getElementById('gate')?.classList.add('gone');
      document.body.classList.remove('locked');
      document.getElementById('envelope')?.classList.add('opened');
      const hint = document.getElementById('hint');
      if (hint) hint.style.opacity = '0';
    };
    skipEnvelope();

    const style = document.createElement('style');
    style.textContent =
      '#photoTop{display:flex;justify-content:center;margin:18px auto 0;padding:0 16px}' +
      '#photoTop .btn{font-size:15px;padding:10px 20px}';
    document.head.appendChild(style);

    const link = (className, text) => {
      const a = document.createElement('a');
      a.className = className;
      a.href = uploadUrl();
      a.textContent = text;
      a.onclick = () => {
        try {
          sessionStorage.setItem(visitKey, String(Date.now()));
        } catch (e) {}
      };
      return a;
    };

    const place = () => {
      if (!available || !invitation.children.length) return;

      if (!document.getElementById('photoLink')) {
        const section = document.createElement('section');
        section.id = 'photoLink';

        const title = document.createElement('h2');
        title.textContent = 'Снимки от гостите';

        const text = document.createElement('p');
        text.textContent =
          'Споделете с нас снимките, които направите. Не е нужна регистрация.';

        section.append(title, text, link('btn', 'Качете снимки'));

        const footer = invitation.querySelector('.footer');
        invitation.insertBefore(section, footer || null);

        if (returning) {
          skipEnvelope();
          returning = false;
          requestAnimationFrame(() =>
            section.scrollIntoView({ block: 'center', behavior: 'auto' })
          );
        }
      }

      // Горен бутон само от началото на сватбата; не е плаващ.
      const weddingAt = Number(invitation.dataset.weddingAt);
      if (
        weddingAt > 0 &&
        Date.now() >= weddingAt &&
        !document.getElementById('photoTop')
      ) {
        const hero = invitation.querySelector('.hero');
        if (hero) {
          const top = document.createElement('div');
          top.id = 'photoTop';
          top.append(link('btn outline', 'Качете Вашите снимки'));
          hero.after(top);
        }
      }
    };

    new MutationObserver(place).observe(invitation, { childList: true });
    setInterval(place, 60000);

    checkAvailable(true)
      .then(value => {
        available = value;
        place();
      })
      .catch(() => {});
  }

  /* ---------- Страницата за качване ---------- */

  if (!uploadPage) return;

  const back = document.getElementById('photoBack');
  if (back) {
    const fromTablo = params.get('from') === 'tablo';
    const target = new URL(fromTablo ? '/pages/moite-pokani' : '/pages/pokana', location.origin);
    if (!fromTablo){target.searchParams.set('s', slug);if(new URLSearchParams(location.search).get('lang')==='en')target.searchParams.set('lang','en');}
    back.href = target.href;

    if (fromTablo) {
      back.textContent = '← Назад към таблото';
    } else {
      back.onclick = () => {
        try {
          const timestamp = Number(sessionStorage.getItem(visitKey));
          if (timestamp > 0 && Date.now() - timestamp < 1800000) {
            sessionStorage.setItem(returnKey, String(Date.now()));
          }
        } catch (e) {}
      };
    }
  }

  const stateBox = document.getElementById('photoState');
  const form = document.getElementById('photoForm');
  const input = document.getElementById('photoFiles');
  const startButton = document.getElementById('photoStart');
  const progress = document.getElementById('photoProgress');
  const results = document.getElementById('photoResults');

  let busy = false;

  function randomId() {
    return Array.from(crypto.getRandomValues(new Uint8Array(32)), b =>
      b.toString(16).padStart(2, '0')
    ).join('');
  }

  function visitorId() {
    let id = '';
    try {
      id = localStorage.getItem('pokani-photo-visitor') || '';
    } catch (e) {}

    if (!/^[0-9a-f]{64}$/.test(id)) {
      id = randomId();
      try {
        localStorage.setItem('pokani-photo-visitor', id);
      } catch (e) {}
    }
    return id;
  }

  // Разпознава формата по съдържанието, не по името на файла.
  async function detectType(file) {
    const bytes = new Uint8Array(await file.slice(0, 64).arrayBuffer());
    const text = (start, length) =>
      String.fromCharCode(...bytes.slice(start, start + length));

    if (bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) return 'image/jpeg';

    if (
      bytes[0] === 0x89 && text(1, 3) === 'PNG' &&
      bytes[4] === 13 && bytes[5] === 10 && bytes[6] === 26 && bytes[7] === 10
    ) {
      return 'image/png';
    }

    if (text(0, 4) === 'RIFF' && text(8, 4) === 'WEBP') return 'image/webp';

    if (text(4, 4) === 'ftyp') {
      const boxSize = ((bytes[0] << 24) | (bytes[1] << 16) | (bytes[2] << 8) | bytes[3]) >>> 0;
      const end = Math.min(bytes.length, boxSize || bytes.length);
      const major = text(8, 4);
      const brands = [major];
      for (let i = 16; i + 4 <= end; i += 4) brands.push(text(i, 4));

      const heic = ['heic', 'heix', 'hevc', 'hevx', 'heim', 'heis'];
      const avif = ['avif', 'avis'];
      const heif = ['mif1', 'msf1', 'heif'];

      if (heic.includes(major)) return 'image/heic';
      if (avif.includes(major)) return 'image/avif';
      if (brands.some(b => avif.includes(b))) return 'image/avif';
      if (brands.some(b => heic.includes(b))) return 'image/heic';
      if (brands.some(b => heif.includes(b))) return 'image/heif';
    }

    return '';
  }

  async function prepare(file, mimeType) {
    const response = await fetch(endpoint, {
      method: 'POST',
      credentials: 'omit',
      cache: 'no-store',
      redirect: 'error',
      signal: AbortSignal.timeout(60000),
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        slug,
        requestId: randomId(),
        visitorId: visitorId(),
        fileBytes: file.size,
        mimeType
      })
    });

    let data = null;
    try {
      data = await response.json();
    } catch (e) {}

    if (!response.ok || !data || data.ok !== true) {
      throw new Error(data && typeof data.code === 'string' ? data.code : 'UNCONFIRMED');
    }

    const destination = new URL(data.uploadUrl);
    if (
      destination.protocol !== 'https:' ||
      destination.hostname !== 'www.googleapis.com' ||
      !destination.pathname.startsWith('/upload/drive/') ||
      destination.username ||
      destination.password ||
      destination.port ||
      data.fileBytes !== file.size ||
      data.mimeType !== mimeType
    ) {
      throw new Error('UNCONFIRMED');
    }

    return destination.href;
  }

  function send(url, file, mimeType, onProgress) {
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      request.open('PUT', url);
      request.timeout = 900000;
      request.setRequestHeader('Content-Type', mimeType);
      request.upload.onprogress = event => {
        if (event.lengthComputable) onProgress(event.loaded / event.total);
      };
      request.onload = () =>
        request.status >= 200 && request.status < 300
          ? resolve()
          : reject(new Error('SEND'));
      request.onerror = request.ontimeout = request.onabort = () =>
        reject(new Error('SEND'));
      request.send(file);
    });
  }

  function row(name) {
    const item = document.createElement('li');
    const label = document.createElement('span');
    label.textContent = name || 'Снимка';
    const status = document.createElement('b');
    status.textContent = 'изчаква';
    item.append(label, status);
    results.appendChild(item);
    return status;
  }

  function lock(value) {
    busy = value;
    input.disabled = value;
    startButton.disabled = value;
  }

  window.addEventListener('beforeunload', event => {
    if (busy) {
      event.preventDefault();
      event.returnValue = '';
    }
  });

  input.addEventListener('change', () => {
    const count = input.files.length;
    progress.textContent = count
      ? 'Избрани снимки: ' + count + (count > MAX_FILES ? ' (изберете до ' + MAX_FILES + ' наведнъж)' : '')
      : '';
  });

  startButton.onclick = async () => {
    if (busy) return;

    const files = Array.from(input.files || []);
    if (!files.length) {
      progress.textContent = 'Първо изберете снимки.';
      return;
    }
    if (files.length > MAX_FILES) {
      progress.textContent = 'Изберете до ' + MAX_FILES + ' снимки наведнъж.';
      return;
    }

    lock(true);
    results.replaceChildren();

    const rows = files.map(file => row(file.name));
    let uploaded = 0;
    let unfinished = 0;
    let stopped = '';

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const status = rows[i];

      if (stopped) {
        status.textContent = 'не е изпратена';
        unfinished++;
        continue;
      }

      if (file.size <= 0 || file.size > MAX_BYTES) {
        status.textContent = 'над 20 MB, пропусната';
        unfinished++;
        continue;
      }

      let mimeType = '';
      try {
        mimeType = await detectType(file);
      } catch (e) {}

      if (!mimeType) {
        status.textContent = 'неподдържан формат';
        unfinished++;
        continue;
      }

      progress.textContent = 'Изпращане ' + (i + 1) + ' от ' + files.length + '… Не затваряйте страницата.';
      status.textContent = 'подготовка…';

      try {
        const url = await prepare(file, mimeType);
        await send(url, file, mimeType, part => {
          status.textContent = Math.round(part * 100) + '%';
        });
        status.textContent = 'качена ✓';
        uploaded++;
      } catch (e) {
        unfinished++;

        if (LIMIT_CODES.includes(e.message)) {
          status.textContent = 'не е изпратена';
          stopped = 'Достигнат е лимит за качване. Опитайте отново след около 10 минути.';
        } else if (e.message === 'UPLOADS_PAUSED' || e.message === 'NOT_AVAILABLE') {
          status.textContent = 'не е изпратена';
          stopped = 'Качването в момента не е включено от домакините.';
        } else if (e.message === 'SEND') {
          status.textContent = 'не е потвърдена';
        } else {
          status.textContent = 'не е изпратена';
        }
      }
    }

    progress.textContent =
      'Качени: ' + uploaded + ' от ' + files.length + '.' +
      (stopped ? ' ' + stopped : '') +
      (unfinished && !stopped ? ' Изберете отново само неуспешните снимки.' : '') +
      (uploaded && !unfinished ? ' Благодарим Ви!' : '');

    input.value = '';
    lock(false);
  };

  stateBox.textContent = 'Проверка…';

  checkAvailable(false)
    .then(value => {
      if (value) {
        stateBox.textContent =
          'Снимките отиват директно в Google Drive папката на домакините. Не е нужен профил. Другите гости не виждат качените снимки.';
        form.hidden = false;
      } else {
        stateBox.textContent = 'Качването на снимки в момента не е включено.';
      }
    })
    .catch(() => {
      stateBox.textContent = 'Не успяхме да проверим. Презаредете страницата.';
    });
})();
